import type { FlowRoute } from './flow-route-types.js';

export interface NavigationButtonsProps {
  previousRoute?: FlowRoute;
  nextRoute?: FlowRoute;
  onBack: () => void;
  onNext: () => void;
  nextLabel?: string;
}

/**
 * Próximo stays enabled even when the step is invalid — clicking it reveals the errors and moves
 * focus to the first one. A disabled button is not focusable, so a screen-reader user would get
 * no signal about why they are stuck. See ADR 0005.
 */
export function NavigationButtons({
  previousRoute,
  nextRoute,
  onBack,
  onNext,
  nextLabel,
}: NavigationButtonsProps) {
  return (
    <div
      className="mt-8 flex flex-col-reverse items-stretch gap-3 border-t border-base-300 pt-6 sm:flex-row sm:items-center sm:justify-between"
      aria-label="Navegação dos primeiros passos"
    >
      <button
        className="btn btn-ghost sm:w-auto"
        type="button"
        onClick={onBack}
        disabled={!previousRoute}
      >
        Voltar
      </button>
      <NextButton nextRoute={nextRoute} onNext={onNext} nextLabel={nextLabel} />
    </div>
  );
}

function NextButton({
  nextRoute,
  onNext,
  nextLabel,
}: Pick<NavigationButtonsProps, 'nextRoute' | 'onNext' | 'nextLabel'>) {
  if (!nextRoute) {
    return null;
  }

  return (
    <button className="btn btn-primary sm:w-auto" type="button" onClick={onNext}>
      {nextLabel ?? 'Próximo'}
    </button>
  );
}
